import {Asset, Response} from "@core/model";
import {ApiBuilder} from "..";

const fetchAssetTree = (builder: ApiBuilder) =>
  builder.query<Asset[], void>({
    query: () => ({
      url: `/api/asset/tree`,
      method: "GET",
    }),
    transformResponse: (response: Response<Asset[]>) => {
      return response.data;
    },
    providesTags: result => (result ? [{type: "asset", id: "tree"}] : []),
  });

const copyAsset = (builder: ApiBuilder) =>
  builder.mutation<void, string>({
    query: assetId => ({
      url: `/api/asset/copy/${assetId}`,
      method: "POST",
    }),
  });

export {fetchAssetTree, copyAsset};
